import React from 'react';
import Login from '../../components/login/login'
import { ToastContainer, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';

import Home from '../../containers/Home'

const smoothToastTransition = cssTransition({
    enter: "toast-smooth-enter",
    exit: "toast-smooth-exit",
    duration: [450, 350],
});

const Dashbord = () => {
    const { user, loader } = useSelector((state) => {
        return {
            user: state.authentication,
            loader: state.loader.loader
        }
    });
    
    return (
        <div>
            <ToastContainer
                position="top-center"
                className="toastContainer"
                transition={smoothToastTransition}
                autoClose={2000}
                hideProgressBar={true}
            />
            {/* {user.envType !== "DEV" && loader && <div id="cover-spin"></div>} */}
            {user.loggedIn || localStorage.getItem('userDetails') ? <Home /> : <Login />}
        </div>
    )
}

export default Dashbord